import '@/features/bouncySums/styles/bouncy-sums-local-hud.scss';

import type { BouncySumsLabels } from '@/features/bouncySums/types';

type BouncySumsLocalHudProps = {
	bpm: number;
	isGameScreen: boolean;
	labels: BouncySumsLabels;
	previousHighScore: number;
	score: number;
	seconds: number;
};

const BouncySumsLocalHud = ({
	bpm,
	isGameScreen,
	labels,
	previousHighScore,
	score,
	seconds,
}: BouncySumsLocalHudProps) => {
	return (
		<div className="bouncy-sums-game__local-hud" aria-hidden={!isGameScreen}>
			<span className="bouncy-sums-game__local-hud-row">
				{labels.previousHighScoreLabel} {previousHighScore}
			</span>
			<span className="bouncy-sums-game__local-hud-row">
				{labels.scoreLabel} {score}
			</span>
			<span className="bouncy-sums-game__local-hud-row">
				{bpm} {labels.bpmLabel}
			</span>
			<span className="bouncy-sums-game__local-hud-row">
				{seconds}
				{labels.secondsSuffix}
			</span>
		</div>
	);
};

export default BouncySumsLocalHud;
